import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/years";


export class YearsApi extends BaseAPI {
  static getYears(): Promise<AxiosResponse> {
    return this.api.get(`${path}`);
  }

}
